/*** IMPORTS FROM imports-loader ***/
var define = false;

// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

